import { useState, type ReactNode } from "react";
import { DndContext, DragOverlay, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";

type DragData = Record<string, unknown>;

interface CalendarDndContextProps {
  /** `data` to `dragData` przeciąganego chipa, `dayKey` to dzień (YYYY-MM-DD), na który upuszczono. */
  onDrop: (data: DragData, dayKey: string) => void;
  renderOverlay: (data: DragData) => ReactNode;
  children: ReactNode;
}

export const CalendarDndContext = ({ onDrop, renderOverlay, children }: CalendarDndContextProps) => {
  const [dragged, setDragged] = useState<DragData | null>(null);
  // Dystans zamiast natychmiastowego startu: klik w chip ma dalej otwierać szczegóły i popover.
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 6 } }));

  return (
    <DndContext
      sensors={sensors}
      onDragStart={({ active }) => {
        // Zamyka otwarte popovery i menu, żeby nie wisiały nad przeciąganym chipem.
        document.body.click();
        setDragged((active.data.current as DragData | undefined) ?? null);
      }}
      onDragEnd={({ active, over }) => {
        setDragged(null);
        const data = active.data.current as DragData | undefined;
        const dayKey = over?.data.current?.day as string | undefined;
        if (data && dayKey) {
          onDrop(data, dayKey);
        }
      }}
      onDragCancel={() => setDragged(null)}
    >
      {children}
      <DragOverlay dropAnimation={null}>{dragged ? renderOverlay(dragged) : null}</DragOverlay>
    </DndContext>
  );
};
